exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category-title .decoration[data-v-871f48d2]{background:var(--categoryTitleBg) 0 0 no-repeat;background-size:100% 100%}.category-title .decoration~span[data-v-871f48d2]{letter-spacing:.14em}", ""]);

// exports
